module.exports = __webpack_public_path__ + "static/collectorcans-slide-img-1-en-CA-8e7621939dc1d057d2bcb0014e456e18.png";